import React, { useEffect, useState } from 'react';
import { Button, Image } from 'react-bootstrap';
import ReactApexChart from 'react-apexcharts';
import { useNavigate } from 'react-router-dom';

import ArrowRightIcon from '../assets/icon/arrowRightCircleB.svg';
import ArrowLeftIcon from '../assets/icon/arrowLeftCircleB.svg';
import ArrowRightCircle from '../assets/icon/arrowRightCircle.svg';
import { IResumoAtendimento } from '../interfaces/IResumoAtendimento';
import DashboardResume from './DashboardResume';

const DashboardFeedback = ({
  atendimentoData,
  setShowDashboardFeedback,
}: {
  atendimentoData: IResumoAtendimento;
  setShowDashboardFeedback: React.Dispatch<React.SetStateAction<boolean>>;
}): JSX.Element => {
  const navigate = useNavigate();

  const dataChartPie = {
    series: [
      atendimentoData?.qtdeFeedbackPositivo || 0,
      atendimentoData?.qtdeFeedbackMedio || 0,
      atendimentoData?.qtdeFeedbackNegativo || 0,
      atendimentoData?.qtdeFeedbackNeutro || 0,
    ],
    options: {
      chart: {
        type: 'pie' as const, // Especificar o tipo explicitamente como "pie"
      },
      labels: [
        'Muito satisfeitos',
        'Satisfeitos',
        'Insatisfeitos',
        'Não avaliados',
      ],
      colors: ['#0075FF', '#FFA300', '#FF2C19', '#C0C0C0'],
      responsive: [
        {
          breakpoint: 1400,
          options: {
            legend: {
              show: false,
              position: 'top',
            },
          },
        },
      ],
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: true,
        formatter(
          val: number,
          opts: { w: { config: { series: number[] } }; seriesIndex: number }
        ) {
          return opts.w.config.series[opts.seriesIndex].toString();
        },
        style: {
          fontSize: '16px',
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 'bold',
          colors: ['#fff'],
        },
      },
    },
  };

  return (
    <div className="w-100 h-100 d-flex flex-column">
      <div
        className="d-flex align-items-center justify-content-between mt-2 ms-4 me-4"
        style={{ flexShrink: 0 }}
      >
        <span style={{ fontSize: '1.68rem', fontWeight: '600' }}>Feedback</span>
        <div
          className="d-flex"
          onClick={() => setShowDashboardFeedback(false)}
          onKeyDown={() => setShowDashboardFeedback(false)}
          role="button"
          tabIndex={0}
        >
          <Image
            src={ArrowLeftIcon}
            alt="ArrowRightIcon"
            style={{ width: '1.75rem', height: '1.75rem' }}
          />
          <Image
            src={ArrowRightIcon}
            alt="ArrowRightIcon"
            className="ms-2"
            style={{ width: '1.75rem', height: '1.75rem' }}
          />
        </div>
      </div>
      <div className="d-flex" style={{ flexShrink: 0 }}>
        <div
          className="d-flex flex-column justify-content-between ms-2 mt-2"
          style={{ height: '16rem' }}
        >
          <div
            style={{
              width: '19.3rem',
              height: '3.44rem',
              wordBreak: 'break-word',
              borderRadius: '0.68rem',
              boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
            }}
            className="d-flex align-items-center"
          >
            <div
              className="rounded-circle ms-4"
              style={{
                height: '0.8rem',
                width: '0.8rem',
                backgroundColor: '#0075FF',
              }}
            />
            <span
              className="ms-3"
              style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                lineHeight: '1.1',
              }}
            >
              Muito Satisfeitos
            </span>
            <div className="flex-grow-1">
              <span
                className="d-flex justify-content-end pe-4"
                style={{ fontSize: '2.5rem', fontWeight: '600' }}
              >
                {atendimentoData.qtdeFeedbackPositivo}
              </span>
            </div>
          </div>
          <div
            style={{
              width: '19.3rem',
              height: '3.44rem',
              wordBreak: 'break-word',
              borderRadius: '0.68rem',
              boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
            }}
            className="d-flex align-items-center"
          >
            <div
              className="rounded-circle ms-4"
              style={{
                height: '0.8rem',
                width: '0.8rem',
                backgroundColor: '#FFA300',
              }}
            />
            <span
              className="ms-3"
              style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                lineHeight: '1.1',
              }}
            >
              Satisfeitos
            </span>
            <div className="flex-grow-1">
              <span
                className="d-flex justify-content-end pe-4"
                style={{ fontSize: '2.5rem', fontWeight: '600' }}
              >
                {atendimentoData.qtdeFeedbackMedio}
              </span>
            </div>
          </div>
          <div
            style={{
              width: '19.3rem',
              height: '3.44rem',
              wordBreak: 'break-word',
              borderRadius: '0.68rem',
              boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
            }}
            className="d-flex align-items-center"
          >
            <div
              className="rounded-circle ms-4"
              style={{
                height: '0.8rem',
                width: '0.8rem',
                backgroundColor: '#FF2C19',
              }}
            />
            <span
              className="ms-3"
              style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                lineHeight: '1.1',
              }}
            >
              Insatisfeitos
            </span>
            <div className="flex-grow-1">
              <span
                className="d-flex justify-content-end pe-4"
                style={{ fontSize: '2.5rem', fontWeight: '600' }}
              >
                {atendimentoData.qtdeFeedbackNegativo}
              </span>
            </div>
          </div>
          <div
            style={{
              width: '19.3rem',
              height: '3.44rem',
              wordBreak: 'break-word',
              borderRadius: '0.68rem',
              boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
            }}
            className="d-flex align-items-center"
          >
            <div
              className="rounded-circle ms-4"
              style={{
                height: '0.8rem',
                width: '0.8rem',
                backgroundColor: '#C0C0C0',
              }}
            />
            <span
              className="ms-3"
              style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                lineHeight: '1.1',
              }}
            >
              Não Avaliados
            </span>
            <div className="flex-grow-1">
              <span
                className="d-flex justify-content-end pe-4"
                style={{ fontSize: '2.5rem', fontWeight: '600' }}
              >
                {atendimentoData.qtdeFeedbackNeutro}
              </span>
            </div>
          </div>
        </div>
        <div
          className="w-100 d-flex align-items-center justify-content-center"
          style={{ height: '18rem' }}
        >
          <ReactApexChart
            options={dataChartPie.options}
            series={dataChartPie.series}
            type="pie"
            width="100%"
            height="100%"
          />
        </div>
      </div>
      <div
        className="mt-3 d-flex flex-column overflow-hidden"
        style={{
          maxHeight: '100%',
          flex: 1,
          backgroundColor: '#D9D9D9',
          borderRadius: '0.68rem',
          boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
        }}
      >
        <div
          className="d-flex align-items-center ms-2 overflow-hidden"
          style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            height: '3.12rem',
          }}
        >
          <span className="ms-2">Status</span>
          <span className="ms-3">Nome</span>
        </div>
        <div
          className="overflow-auto"
          style={{
            flex: 1,
            backgroundColor: '#FFF',
            marginLeft: '0.2rem',
            marginRight: '0.2rem',
          }}
        >
          <DashboardResume
            atendimentoData={atendimentoData.avaliacaoAtendimento}
          />
        </div>
        <div style={{ height: '3.2rem', backgroundColor: '#D9D9D9' }}>
          <Button
            variant="primary"
            type="button"
            className="ms-4 mt-1"
            style={{
              fontSize: '1.125rem',
              fontWeight: '600',
              height: '2.6rem',
              margin: '0',
            }}
            onClick={() => {
              navigate(`/Feedback?dashboard=7`);
              window.focus();
            }}
          >
            <div className="d-flex align-items-center">
              <Image
                src={ArrowRightCircle}
                alt="Seta direita"
                style={{ height: '1.37rem', width: '1.37rem' }}
              />
              <span className="ms-2">ver mais</span>
            </div>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DashboardFeedback;
